import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { CameraCard } from '@/entities/camera'
import { Offcanvas } from '@/entities/offcanvas'
import { useCameraItem } from '@/shared/api/cameras'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/administration/reference-books/cameras/$cameraId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()
  const { cameraId } = Route.useParams()
  const { data: camera, isLoading, isError } = useCameraItem({ id: cameraId })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка камеры')}>
      <CameraCard camera={camera?.camera} isLoading={isLoading} isError={isError} />
    </Offcanvas>
  )
}
